// extracted by mini-css-extract-plugin
module.exports = {"form-structure-group":"style_form-structure-group__XWjqi"};